"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _collection = _interopRequireDefault(require("../common/collection"));
var _constants = require("../constants");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * @class MeetingInfoCollection
 */
var MeetingInfoCollection = /*#__PURE__*/function (_Collection) {
  (0, _inherits2.default)(MeetingInfoCollection, _Collection);
  var _super = _createSuper(MeetingInfoCollection);
  /**
   * @memberof MeetingInfoCollection
   * @constructor
   * @public
   */
  function MeetingInfoCollection() {
    var _this;
    (0, _classCallCheck2.default)(this, MeetingInfoCollection);
    _this = _super.call(this, 'meetingInfos');
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "namespace", _constants.MEETINGS);
    return _this;
  }

  /**
   * @param {String} id ID of the meeting info you wish to retreive
   * @returns {MeetingInfo} returns a meeting info instance
   * @public
   * @memberof MeetingInfoCollection
   */
  (0, _createClass2.default)(MeetingInfoCollection, [{
    key: "get",
    value: function get(id) {
      // @ts-ignore
      if (this.meetingInfos[id]) {
        // @ts-ignore
        return this.meetingInfos[id];
      }
      return (0, _find2.default)(
      // @ts-ignore
      this.meetingInfos, function (info) {
        return info.sipUrl === id || info.locusId === id || info.userId === id || info.meetingLink === id;
      });
    }
  }]);
  return MeetingInfoCollection;
}(_collection.default);
exports.default = MeetingInfoCollection;
//# sourceMappingURL=collection.js.map
